import * as React from "react";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import Page from "components/Page";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";

const RemoteSynchronizationSettingsApp = React.lazy(
  () => import("codat-synchronization-settings-ui/App")
);

const SynchronizationSettings = () => (
  <Page>
    <React.Suspense fallback={<PageLoadingSkeleton />}>
      <ErrorBoundary>
        <RemoteSynchronizationSettingsApp />
      </ErrorBoundary>
    </React.Suspense>
  </Page>
);

export default SynchronizationSettings;
